import { api } from '../../shared/api/client'
import type {
  InsertCard,
  InsertPreview,
  SlideInsert,
  SlideInsertInput,
  ScopeSearchParams,
  ScopeSearchResult,
} from './types'

const unwrap = <T>(response: any): T => response?.data?.data ?? response?.data
const base = '/slide-inserts'
export const slideInsertsAPI = {
  scopeSearch: async (params: ScopeSearchParams, signal?: AbortSignal) =>
    unwrap<ScopeSearchResult>(await api.get(`${base}/scope-search`, { params, signal })),
  list: async (params: Record<string, unknown> = {}, signal?: AbortSignal) =>
    unwrap<{ items: SlideInsert[]; total: number; pending: number }>(
      await api.get(base, { params, signal }),
    ),
  get: async (id: number) => unwrap<SlideInsert>(await api.get(`${base}/${id}`)),
  preview: async (input: SlideInsertInput, signal?: AbortSignal) =>
    unwrap<InsertPreview | { jobId: string }>(await api.post(`${base}/preview`, input, { signal })),
  create: async (input: SlideInsertInput) => {
    const created = unwrap<SlideInsert>(await api.post(base, input))
    return created.counts ? created : unwrap<SlideInsert>(await api.get(`${base}/${created.id}`))
  },
  update: async (id: number, input: SlideInsertInput) =>
    unwrap<SlideInsert | { jobId: string }>(await api.put(`${base}/${id}`, input)),
  cards: async (id: number, params: Record<string, unknown> = {}) => {
    const { status, ...rest } = params
    const filter = ['skipped', 'excluded'].includes(String(status))
      ? { state: status }
      : status
        ? status === 'draft'
          ? { send_state: 'not_needed', state: 'included' }
          : { send_state: status }
        : {}
    const data = unwrap<{ items: Array<InsertCard & { state?: string }>; total: number }>(
      await api.get(`${base}/${id}/cards`, { params: { ...rest, ...filter } }),
    )
    return {
      ...data,
      items: data.items.map((row) => ({
        ...row,
        status: ['excluded', 'skipped'].includes(row.state || '')
          ? row.state!
          : row.send_status === 'not_needed'
            ? 'draft'
            : row.send_status === 'failed'
              ? 'pending'
              : row.send_status || row.status,
      })),
    }
  },
  action: async (
    id: number,
    action: 'apply' | 'disable' | 'replace-image' | 'recalc' | 'send',
    body: Record<string, unknown> = {},
  ) =>
    unwrap<{ jobId?: string; added?: number; removed?: number }>(
      await api.post(`${base}/${id}/${action}`, body),
    ),
  setExcluded: async (id: number, cardId: number, excluded: boolean) =>
    unwrap<{ jobId?: string }>(
      await api.post(`${base}/${id}/cards/${cardId}/${excluded ? 'exclude' : 'include'}`),
    ),
  delete: async (id: number) => api.delete(`${base}/${id}`),
}
export function insertError(error: unknown): string {
  const e = error as {
    message?: string
    response?: { data?: { message?: string; error?: { message?: string } } }
  }
  return (
    e.response?.data?.error?.message ||
    e.response?.data?.message ||
    e.message ||
    'Не удалось выполнить действие'
  )
}
